import React from "react"

import { InfoIcon } from "@atos6/icons"
import { Space } from "@atos6/ui"
import { HCenter, Padding, TitleCenter } from "../../ui"

export function InfoCell() {
  return (
    <>
      <Padding>
        <HCenter>
          <div style={{ width: 64, height: 64 }}>
            <InfoIcon />
          </div>
        </HCenter>
      </Padding>
      <Space>
        <TitleCenter>
          Para receber doações é necessário preencher os dados bancários
        </TitleCenter>
      </Space>
    </>
  )
}
